import { action, computed } from 'easy-peasy';
import { Presentation } from 'schema';

const pptModel = {
  pptJson: null,
  selectedSlideIndex: 0,
  selectedElementId: null,
  editingTextShapeId: null,
  scriptsByScene: {},
  updatingScriptsByProject: {},

  setPPTJSON: action((state, payload) => {
    state.pptJson = payload;
  }),
  setSelectedSlideIndex: action((state, payload) => {
    state.selectedSlideIndex = payload;
  }),
  setSelectedElementId: action((state, payload) => {
    state.selectedElementId = payload;
  }),
  setEditingTextShapeId: action((state, payload) => {
    state.editingTextShapeId = payload;
  }),
  setScriptsByScene: action((state, payload) => {
    const current =
      state.scriptsByScene && typeof state.scriptsByScene === 'object' ? state.scriptsByScene : {};
    state.scriptsByScene = typeof payload === 'function' ? payload(current) : payload || {};
  }),
  setIsUpdatingScripts: action((state, { projectId, value }) => {
    if (!projectId) return;
    if (value) state.updatingScriptsByProject[projectId] = true;
    else delete state.updatingScriptsByProject[projectId];
  }),

  // Computed slideData - returns null if no pptJson
  slideData: computed((state) => {
    if (!state.pptJson) return null;
    try {
      return Presentation.fromJSON(state.pptJson);
    } catch (error) {
      console.error('Error parsing PPT JSON:', error);
      return null;
    }
  })
};

export default pptModel;
